module.exports = __webpack_public_path__ + "25fb3dff2e95c071d389199e520dd61e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/1_C2.mp3
// module id = 76
// module chunks = 0